import {Routes, UrlSegment} from '@angular/router';
import {Error404Component} from "@features/error/components/404.component";
import {LegacyAppConversationRedirectGuard} from '@core/guards';

/**
 * Danh sách các đường dẫn (paths) sẽ sử dụng Layout Public (Landing page, Checkout,...)
 * Sau này nếu có trang public mới, chỉ cần thêm tên path vào mảng này.
 */
const PUBLIC_PATHS = ['', 'checkout', 'genaitemplates', 'pricing', 'privacy-policy', 'privacy-terms', 'blog', 'bot'];

/**
 * Hàm Matcher thông minh:
 * - Nếu URL thuộc danh sách PUBLIC_PATHS -> Trả về kết quả khớp (nhưng không nuốt segment) để Layout Public xử lý.
 * - Nếu không thuộc -> Trả về null để Router nhảy xuống xử lý ở Layout Admin/Web bên dưới.
 */
export function publicLayoutMatcher(segments: UrlSegment[]) {
  const path = segments.length > 0 ? segments[0].path : '';
  if (PUBLIC_PATHS.includes(path)) {
    // Trả về consumed: [] để Router hiểu là khớp nhưng KHÔNG nuốt segment.
    // Việc này giúp các module con bên trong vẫn thấy được URL đầy đủ (VD: /checkout) để hiển thị đúng component.
    return {consumed: []};
  }
  return null; // Không khớp -> Nhường quyền cho route tiếp theo
}

export const AppRoutes: Routes = [
  {
    path: 'app/conversation',
    canActivate: [LegacyAppConversationRedirectGuard],
    component: Error404Component,
  },
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.module').then(m => m.AuthModule),
  },
  {
    matcher: publicLayoutMatcher, // <--- Sử dụng Matcher tự động hóa
    loadChildren: () => import('@layouts/layout-public/layout-public.module').then(m => m.LayoutPublicModule),
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('@layouts/layout-web/layout-web.module').then(m => m.LayoutWebModule),
      },
      {
        path: 'error',
        loadChildren: () => import('@features/error/error.module').then((m) => m.ErrorModule)
      },
      {path: '**', component: Error404Component},
    ],
  }
];
